import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { Link } from "gatsby"
import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTwitter } from "@fortawesome/free-brands-svg-icons"
import avatar from "../images/avatar.jpg"

const Container = styled.div`
  @media (max-width: 1000px) {
    display: block;
  }
`
const Sidebar = styled.div`
  height: 30%;
  @media (max-width: 1000px) {
    width: 90%;
    margin: 0 auto;
  }
`
const ContentBlock = styled.div`
  @media (max-width: 1000px) {
    width: 100%;
  }
`

export default ({ data }) => {
  return (
    <Layout>
      <SEO title="my own pace..." />
      <Container className="container flex mx-auto mb-10 flex">
        <ContentBlock className="w-9/12">
          {data.allMarkdownRemark.edges.map(({ node }) => (
            <div className="w-full mb-3 px-6">
              <Link
                to={node.fields.slug}
                className="font-bold text-xl mb-2"
                style={{ textDecoration: "none" }}
              >
                <div className="rounded overflow-hidden shadow bg-white">
                  <div className="px-6 py-4">{node.frontmatter.title}</div>
                  <p className="px-6 text-xs text-gray-500 px-2 mb-4">
                    {node.frontmatter.date}
                  </p>
                </div>
              </Link>
            </div>
          ))}
        </ContentBlock>
        <Sidebar className="w-1/4 rounded bg-white">
          <img className="w-full" src={avatar} alt="Sunset in the mountains" />
          <div className="px-6 py-4">
            <div className="font-bold text-center text-xl mb-2">
              けんぞう@独学の人
              <br />
              <a href="https://twitter.com/kenzoooooB">
                <FontAwesomeIcon className="text-blue-400" icon={faTwitter} />
              </a>
            </div>
            <p className="text-gray-700 text-sm">
              プログラミングを独学しています。
              最近は恵比寿の企業さんでエンジニアとしてインターンをしています。
            </p>
          </div>
        </Sidebar>
      </Container>
    </Layout>
  )
}

export const query = graphql`
  query {
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      totalCount
      edges {
        node {
          id
          frontmatter {
            title
            date(formatString: "YYYY.MM.DD")
          }
          fields {
            slug
          }
          excerpt
        }
      }
    }
  }
`
